export {default as interpolate} from "./value";
export {default as interpolateArray} from "./array";
export {default as interpolateBasis} from "./basis";
export {default as interpolateBasisClosed} from "./basisClosed";
export {default as interpolateDate} from "./date";
export {default as interpolateDiscrete} from "./discrete";
export {default as interpolateHue} from "./hue";
export {default as interpolateNumber} from "./number";
export {default as interpolateObject} from "./object";
export {default as interpolateRound} from "./round";
export {default as interpolateString} from "./string";
export {interpolateTransformCss, interpolateTransformSvg} from "./transform/index";
export {default as interpolateZoom} from "./zoom";
export {default as interpolateRgb, rgbBasis as interpolateRgbBasis, rgbBasisClosed as interpolateRgbBasisClosed} from "./rgb";
export {default as interpolateHsl, hslLong as interpolateHslLong} from "./hsl";
export {default as interpolateLab} from "./lab";
export {default as interpolateHcl, hclLong as interpolateHclLong} from "./hcl";
export {default as interpolateCubehelix, cubehelixLong as interpolateCubehelixLong} from "./cubehelix";
export {default as piecewise} from "./piecewise";
export {default as quantize} from "./quantize";



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/index.js
// module id = JyCv
// module chunks = 0